export class TicketUnreadUser {
	ID:number = 0;
	TicketID:number = 0;
	UserID:number = 0;

	public constructor(data:any){
		this.ID = data.ID;
		this.TicketID = data.TicketID;
		this.UserID = data.UserID;
	}
}